const STORAGE_KEY = 'fiat-arcade:sessao:v1';

/**
 * Vínculo tablet ↔ participante (`RN-CRE-04`/`RN-CRE-05`): depois do login,
 * a associação com turma e grupo permanece salva durante toda a jornada.
 * A sessão de teste nunca é persistida — recarregar o app volta ao login.
 */
class SessaoService {
    constructor (armazenamento = globalThis.localStorage, chave = STORAGE_KEY) {
        this._armazenamento = armazenamento;
        this._chave = chave;
        this._atual = null;
        this._carregar();
    }

    get atual () { return this._atual; }
    get ativa () { return this._atual !== null; }
    get ehTeste () { return Boolean(this._atual?.teste); }
    get token () { return this._atual?.token ?? null; }

    /** "GRUPO 1 • CARLOS ALBERTO" — rótulo do cabeçalho das telas. */
    get rotulo () {
        if (!this._atual) return '';
        const primeiros = this._atual.nome.split(/\s+/).slice(0, 2).join(' ');
        return `${this._atual.grupo} • ${primeiros}`.toUpperCase();
    }

    iniciar (sessao) {
        this._atual = { ...sessao };
        if (!sessao.teste) this._gravar();
        return this._atual;
    }

    encerrar () {
        this._atual = null;
        try { this._armazenamento?.removeItem(this._chave); } catch { /* sem storage */ }
    }

    _gravar () {
        try {
            this._armazenamento?.setItem(this._chave, JSON.stringify(this._atual));
        } catch (erro) {
            console.warn('[Sessao] não foi possível persistir o vínculo.', erro);
        }
    }

    _carregar () {
        try {
            const bruto = this._armazenamento?.getItem(this._chave);
            if (bruto) this._atual = JSON.parse(bruto);
        } catch {
            this._atual = null;
        }
    }
}

export { SessaoService };
export const Sessao = new SessaoService();

/** Vínculo tablet ↔ estação do facilitador: outra chave, para nunca se misturar com o do participante. */
export const SessaoEstacao = new SessaoService(globalThis.localStorage, 'fiat-arcade:sessao-estacao:v1');
